import './green.scss';
import  Form from '../../components/form/Form';
import Api from '../../requests/Api';
// import MoscowClock from '../../components/other/MoscowClock/MoscowClock';
import NewYearTimer from '../../components/other/NewYearTimer/NewYearTimer';
import Popup from '../../components/other/Popup/Popup';
import SuccesPopup from '../../components/other/SuccesPopup/Popup';
import FinalPopup from '../../components/other/FinalPopup/Popup';
import PrisePopup from '../../components/other/PrisePopup/Popup';
import PolisPopup from '../../components/other/PrisePopup/Popup';


(function () {
	document.addEventListener('DOMContentLoaded', () => {
		let promocodeText = window.userData?.promocode || "Нет промокода";
		const promocodeElements = document.querySelectorAll('.promocode');
		const forms = document.querySelectorAll('.js-form');
		const $Popup = document.querySelector('.js-popup');
		const $SuccesPopup = document.querySelector('.js-succes-popup');
		const $succespopup = new SuccesPopup($SuccesPopup);
		const $popup = new Popup($Popup);
		const $FinalPopup = document.querySelector('.js-final-popup');
		const $finalpopup = new FinalPopup($FinalPopup);
		const $PrisePopup = document.querySelector('.js-prise-popup');
		const $prisePopup = new PrisePopup($PrisePopup);
		const $PolisPopup = document.querySelector('.js-polis-popup');
		const $polisPopup = new PolisPopup($PolisPopup);
		const elements = document.querySelectorAll('.js-target-class');
		const closeAll = document.querySelectorAll('.js-close-form');
		const popups = document.querySelectorAll('.js-popup');
		var opened = false
		const openedPopups = new Set();

		document.getElementById('showPrise').addEventListener('click', () =>
			{
				$prisePopup.showPopup('prise')
			}
		)
		document.getElementById('openPolis').addEventListener('click', () =>
			{
				$polisPopup.showPopup('polis')
			}
		)


		closeAll.forEach((button) => {
			button.addEventListener('click', () => {
				popups.forEach((popup) => {
					popup.classList.remove('is-active');
					const body = document.body;

					//Разблокируем боди после окончания анимации
					setTimeout(function () {
						document.getElementById('product').scrollIntoView({ behavior: 'smooth' });
						body.style.overflow = 'visible';
					}, 500);
				});
			});
		});

		const $Api = new Api();
		let formsCollection = {};



		const scrollMapping = [
			{ buttonId: 'scrollToForm', targetId: 'formBlock' },
			{ buttonId: 'scrollToForm2', targetId: 'formBlock' },
			{ buttonId: 'scrollToForm3', targetId: 'formBlock' },
			{ buttonId: 'scrollToMap', targetId: 'map' },
			{ buttonId: 'scrollToPredict', targetId: 'Predict' },
			{ buttonId: 'scrollToProduct', targetId: 'product' }
		];


		function addSmoothScroll(buttonId, targetId) {
			const button = document.getElementById(buttonId);
			const target = document.getElementById(targetId);

			if (button && target) {
				button.addEventListener('click', () => {
					target.scrollIntoView({ behavior: 'smooth' });
				});
			}
		}

		scrollMapping.forEach(({ buttonId, targetId }) => addSmoothScroll(buttonId, targetId));





		// Универсальная функция для копирования текста
		function addCopyHandler(buttonId, promoClass) {
			const copyButton = document.getElementById(buttonId);
			const promocodeElement = document.querySelector(`.${promoClass}`);

			if (copyButton && promocodeElement) {
				copyButton.addEventListener('click', () => {
					const promoText = promocodeElement.textContent.trim();

					if (promoText) {
						navigator.clipboard.writeText(promoText)
							.then(() => {
								alert('Промокод скопирован: ' + promoText);
							})
							.catch(err => {
								console.error('Ошибка копирования: ', err);
							});
					} else {
						alert('Нет текста для копирования');
					}
				});
			}
		}

		addCopyHandler('copyButton', 'promocode');
		addCopyHandler('copyButton2', 'promocode2');
		addCopyHandler('copyButton3', 'promocode3');
		addCopyHandler('copyButton4', 'promocode4');
		addCopyHandler('copyButton5', 'promocode5');


		forms.forEach(($form) => {
			const formName = $form.getAttribute('data-name');
			const elementsList = $form.querySelectorAll('.js-cell');
			let $Form = {};

			switch (formName) {
				case 'bigForm':
					$Form = new Form($form, submitForm);
					break;
			}

			elementsList.forEach(($el) => {
				const elName = $el.getAttribute('data-name');
				// const elClassName = $el.getAttribute('data-class');

				switch (elName) {
					case 'hiddenProduct':
						$Form.addFormElement($el, {
							onChange:  changeInput2.bind(this, formName),
						});
						break;
					default:
						$Form.addFormElement($el, {
							onChange: changeInput.bind(this, formName),
						});
				}


			});
			formsCollection[formName] = $Form;
		});

		const policy = formsCollection['bigForm'].formElements['policy']
		const program = formsCollection['bigForm'].formElements['policy']

		policy.hideCell()

		function changeInput2(formName) {

			const productMapping = {
				BVB: 'Комбинация из&nbsp;14-18&nbsp;символов&nbsp;без&nbsp;пробела, пример:пример:&nbsp;БРАСР2040000066452',
				FZ: 'Комбинация&nbsp;из&nbsp;17&nbsp;символов без&nbsp;пробела,&nbsp;пример:&nbsp;СМР000А0000192518',
				UK: 'Комбинация&nbsp;из&nbsp;19&nbsp;или&nbsp;20&nbsp;символов&nbsp;без пробела,&nbsp;пример:&nbsp;КАБКВСЛР400000576670',
				GK: 'Комбинация&nbsp;из&nbsp;20&nbsp;символов&nbsp;без пробела,&nbsp;пример:&nbsp;ВАААМСКР500000640060'
			};

// Получаем текущее значение
			const SelectProduct2 = formsCollection['bigForm'].formElements['hiddenProduct'].currentValue;
			const helper = document.getElementById('infohelper')
			program.chosenProgram(SelectProduct2)
// Проверяем, есть ли значение в списке
			if (productMapping.hasOwnProperty(SelectProduct2)) {
				const result = productMapping[SelectProduct2];

				policy.errorChange(result)
				helper.innerHTML = result

				console.log(`Значение для ${SelectProduct2}: ${result}`);
			} else {
				console.log('Значение не найдено в списке.');
			}

			if (SelectProduct2) {
				policy.showCell()
			}
		}

		function changeInput(formName) {
			console.log('formName', formName)

		}
		function getCsrfTokenFromInput() {
			const csrfInput = document.querySelector('input[name="_csrf"]');
			return csrfInput ? csrfInput.value : null; // Возвращает значение или null, если элемент не найден
		}

		// Использование
		const csrfToken = getCsrfTokenFromInput();
		function submitForm() {
			console.log("this", this)
			this.$form.blockingFormButton
			const formData = new FormData(this.$form);
			formData.append('_csrf', csrfToken);
			formData.delete('agreement')
			formData.delete('agreement2')
			formData.append('agreement', 1);
			formData.append('agreement2', 1);
			formData.append('page', 'green');
			$Api.sendShortForm(formData).then((res) => {
				if (res.success === false) {
					// Проверяем наличие поля errors и вытаскиваем первый элемент
					if (res.errors && typeof res.errors === 'object') {
						const firstErrorKey = Object.keys(res.errors)[0]; // Получаем первый ключ из errors
						const firstErrorMessage = res.errors[firstErrorKey][0]; // Получаем первый элемент массива
						formsCollection['bigForm'].formElements[firstErrorKey].errorStatus(firstErrorMessage);
						console.log(`Ошибка: ${firstErrorMessage}`);
					} else {
						console.error('Поле errors отсутствует или имеет некорректный формат.');
					}
				} else {
					console.log('Успешный ответ.');
					// $succespopup.showPopup('succes')
					const formBlock = document.querySelector('.form-block');
					const element = document.getElementById("mailConnect");
					if (element) {
						element.style.display = "flex";
					}
					const formTitle = document.getElementById('formBlock');
					formTitle.innerText = 'Вы великолепны!'
					formBlock.innerHTML = `
    <h3 style="text-align: center">Спасибо за регистрацию!</h3>
    <img src="/new_year2025/dist/assets/img/pages/gift2.png" alt="" style="max-height: 542px;max-width: 100%; width: 474px; margin: auto;">
    <p style="text-align: center">Ваши данные отправлены для участия в акции. <br>Список победителей будет опубликован не позднее <b>конца апреля 2025 года.</b> </p>
  `;
					ym(99015968,'reachGoal',' PremierNGForm');
				}
			});
		}



		function areAllLinksTrueInGreenPage(userData) {
			if (userData.greenPage) {
				// Проверяем, что все значения в greenPage равны true
				return Object.values(userData.greenPage).every(value => value === true);
			}
			return false; // Если greenPage отсутствует
		}

		let openedPop
		console.log(window.userData)
		elements.forEach(element => {
			element.addEventListener('click', (event) => {
				// Получаем значение атрибута data-id
				const dataId = event.target.dataset.id;

				// Добавляем dataId в Set (уникальные значения)

				openedPopups.add(dataId);
				// if (opened) {
				// 	$finalpopup.showPopup();
				// } else {
				// 	$popup.showPopup(dataId);
				// }

				// Проверяем, были ли открыты все семь попапов
				if (openedPopups.size === elements.length) {
					opened = true
				}

				const formData = new FormData();

// Добавляем данные
				formData.append('page', 'green'); // Можно заменить на 'pink'
				formData.append('target', dataId);
				formData.append('_csrf', csrfToken);



				$Api.click(formData).then((res) => {
					window.userData = res;
					console.log(window.userData);
					const allLinksTrue = areAllLinksTrueInGreenPage(window.userData);

					if (openedPop) {
						$Api.promo().then((res) => {
							promocodeText = res.code;
							// Заменяем текст внутри каждого элемента
							promocodeElements.forEach((element) => {
								element.textContent = promocodeText;
							});
						});

						$finalpopup.showPopup();
					} else {
						$popup.showPopup(dataId);
					}

					openedPop = !!allLinksTrue;

				});



				console.log(`Вы нажали на элемент с data-id: ${dataId}`);
				console.log(`Открытые попапы:`, [...openedPopups]);
			});
		});


		const showPredictionsBtn = document.getElementById('show-predictions');
		const prepareBlock = document.getElementById('prepare');
		const promocodeElement = document.querySelectorAll('.promo-code'); // Пример: элементы с классом для промокода

		// Функция-обработчик по клику
		function handleShowPredictionsClick() {
			// Удаляем слушатель, чтобы повторно не нажимали
			showPredictionsBtn.removeEventListener('click', handleShowPredictionsClick);

			// Скрываем все элементы с классом "third"
			const thirdElements = document.querySelectorAll('.third');
			thirdElements.forEach(element => {
				element.style.opacity = '0'; // Анимация скрытия
				element.style.transform = 'translateY(-20px)';
				setTimeout(() => {
					element.classList.add('hidden');
				}, 500);
			});

			// Скрываем блок Prepare
			prepareBlock.style.opacity = '0';
			prepareBlock.style.transform = 'translateY(-20px)';
			setTimeout(() => {
				prepareBlock.classList.add('hidden');
			}, 500);

			// 1) Запрашиваем предсказание
			$Api.predict()
				.then((resPredict) => {
					// 2) Когда предсказание пришло, делаем запрос на промо
					return $Api.promo().then((resPromo) => {
						const promocodeText = resPromo.code;
						promocodeElements.forEach(element => {
							element.textContent = promocodeText;
						});

						// Показываем блок с предсказанием
						const predictionsBlock = document.getElementById(resPredict.product);
						const textContent = predictionsBlock.querySelector('.text-predictions');
						textContent.innerHTML = resPredict.prediction;

						setTimeout(() => {
							predictionsBlock.style.opacity = '1';
							predictionsBlock.style.transform = 'translateY(0)';
							predictionsBlock.classList.remove('hidden');
							showPredictionsBtn.addEventListener('click', handleShowPredictionsClick);
						}, 1000);

						// Логика для статуса
						if (resPredict.status === 200) {
							console.log("succeeded");
						} else {
							console.log("error");
						}
					});
				})
				.catch((err) => {
					// Обработка любой ошибки
					console.error("API Error:", err);
				})
		}

		// Подключаем обработчик к кнопке
		showPredictionsBtn.addEventListener('click', handleShowPredictionsClick);


		// const clock = new MoscowClock(
		// 	'.hours',
		// 	'.minutes',
		// 	'.seconds'
		// );
		// clock.start();

		// Инициализация таймера
		const timer = new NewYearTimer(
			'2025-04-28T00:00:00', // Конечная дата (28 апреля 2025, 00:00 по Москве)
			'#days',              // Селектор для дней
			'#hours',             // Селектор для часов
			'#minutes',           // Селектор для минут
			'#seconds'            // Селектор для секунд
		);
		timer.start();

		console.log('init green')

		// Получаем параметры (search) из текущего URL
		const currentSearch = window.location.search;

		// Если в текущем URL вообще нет GET-параметров, можно ничего не делать
		if (!currentSearch) return;

		// Ищем все ссылки <a> с классом "meta"
		const metaLinks = document.querySelectorAll('a.meta');

		metaLinks.forEach(link => {
			link.addEventListener('click', function(e) {
				// Парсим href ссылки как объект URL
				const url = new URL(link.href);

				// Считываем параметры из текущего URL (страницы)
				const currentParams = new URLSearchParams(window.location.search);

				// Пробегаемся по всем параметрам текущего URL и добавляем/обновляем в ссылке
				currentParams.forEach((value, key) => {
					url.searchParams.set(key, value);
				});

				// Устанавливаем обновлённый href
				link.href = url.toString();
				window.location.href = link.href
			});
		});
	});
	class MillionDropdown {
		constructor() {
			this.dropdownItems = document.querySelectorAll('.million-dropdown__item');
			this.addEventListeners();
		}

		addEventListeners() {
			this.dropdownItems.forEach(item => {
				const title = item.querySelector('.million-dropdown__title');
				title.addEventListener('click', () => this.toggleDropdown(item));
			});
		}

		toggleDropdown(item) {
			item.classList.toggle('is-active');
			const content = item.querySelector('.million-dropdown__content');
			if (item.classList.contains('is-active')) {
				content.style.height = content.scrollHeight + 'px';
				content.style.visibility = 'visible';
			} else {
				content.style.height = '0';
				content.style.visibility = 'hidden';
			}
		}
	}

	document.addEventListener('DOMContentLoaded', () => {
		new MillionDropdown();
	});
})();
